import React, { FunctionComponent } from 'react';

type Props = {
  className: string;
  defaultValue: string;
  personId?: number | string;
  personSrc?: string;
  personName?: string;
  dataCategory?: string;
  dataValue?: string;
  disabled?: boolean;
  onClicked: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export const Presentation: FunctionComponent<Props> = ({
  className,
  defaultValue,
  personId = '',
  personSrc = '',
  personName = '',
  dataCategory,
  dataValue,
  disabled,
  onClicked,
}) => {
  const url = typeof window !== 'undefined' ? window.location.href : '';

  const getDataCategory = (() => {
    if (['スカウト済み', 'スカウト', '気になる'].includes(defaultValue)) {
      return 'scout_user_list';
    } else if (defaultValue === '送信') {
      return 'scout_message';
    } else if (
      url.includes('/companies') &&
      url.includes('/recruitments') &&
      className.includes('recruitment__show__follow__btn')
    ) {
      return 'stopcompanyrecruitmentlist';
    } else if (url.includes('/recruitments') && className.includes('recruitment__show__follow__btn')) {
      return 'stoprecruitmentcontent';
    } else if (url.includes('/companies') && className.includes('recruitment__show__follow__btn')) {
      return 'stopcompanycontent';
    } else if (url.includes('/companies') && className.includes('company-index-card-follow-btn')) {
      return 'companylist';
    } else if (url.includes('/users') && className.includes('company-index-card-follow-btn')) {
      return 'followeecontent';
    } else if (
      url.includes('/brands') &&
      (className.includes('recruitment__show__follow__btn') ||
        className.includes('recruitment__show__follow__form--button'))
    ) {
      return 'stopbrandcontent';
    } else if (className.includes('company-info-page-profile-follow-btn')) {
      return 'companycontent';
    } else if (dataCategory === 'companyadmin_recruitment_applicant') {
      return 'companyadmin_recruitment_applicant';
    } else {
      return '';
    }
  })();

  const getDataValue = (() => {
    if (defaultValue === 'スカウト済み' || defaultValue === 'スカウト') {
      return 'scout';
    } else if (defaultValue === '気になる') {
      return 'like';
    } else if (defaultValue === '送信') {
      return 'scout_sent';
    } else if (defaultValue === '通知を受け取る') {
      return 'notification';
    } else if (defaultValue === '登録完了') {
      return 'notification_register_complete';
    } else if (defaultValue === 'フォローする') {
      return 'follow';
    } else if (defaultValue === 'フォロー中') {
      return 'unfollow';
    } else if (dataValue === 'search_button') {
      return 'search_button';
    } else {
      return '';
    }
  })();

  const getDataEventName =(() => {
    if (defaultValue === 'フォローする' || defaultValue === 'フォロー中') {
      return 'follow on screen';
    } else {
      return 'button on screen';
    }
  })();

  return (
    <button
      type="button"
      className={className}
      onClick={onClicked}
      data-event-name={getDataEventName}
      data-id={personId}
      data-src={personSrc}
      data-name={personName}
      data-event="click"
      data-category={getDataCategory}
      data-value={getDataValue}
      disabled={disabled}
    >
      {defaultValue}
    </button>
  );
};
